import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container className="d-flex min-vh-100 align-items-center justify-content-center">
      <Row className="text-center">
        <Col>
          <h1 className="fs-3 fw-semibold text-secondary mt-4 mb-3">
            Oops, why you're here?
          </h1>
          <p className="mb-2 text-light-emphasis">
            We're very sorry for the inconvenience. It looks like you're trying
            to access a page <br className="d-none d-md-block" /> that either has been deleted or never existed.
          </p>
          <Button
            variant="secondary"
            className="mt-3"
            onClick={() => navigate("/login")}
          >
            RETURN HOME
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default PageNotFound;
